import { useState } from "react";
import axios from "axios";
import { Twitter, Send, Instagram, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { FOOTER } from "@/data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/subscribe`, { email });
      toast.success("Subscribed. Welcome to AUVRA.");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="border-t border-white/10 bg-auvra-surface pt-20 pb-10" data-testid="footer">
      <div className="container-auvra">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16">
          <div className="lg:col-span-4">
            <div className="flex items-center mb-6">
              <img src="/brand/auvra-logo-trim.png" alt="AUVRA" className="h-10 w-auto" />
            </div>
            <p className="text-secondary-auvra max-w-sm leading-relaxed mb-6">
              Institutional infrastructure for compliant real-world asset tokenization.
            </p>
            <form onSubmit={subscribe} className="flex max-w-sm gap-2" data-testid="newsletter-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                data-testid="newsletter-input"
                className="flex-1 bg-black border border-white/15 rounded-full px-4 py-3 text-sm focus:outline-none focus:border-auvra-blue transition-colors"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="newsletter-submit"
                className="bg-auvra-blue hover:bg-auvra-blue/90 disabled:opacity-60 text-white rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0 transition-all"
              >
                <ArrowRight className="w-4 h-4" />
              </button>
            </form>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-5 gap-8">
            {Object.entries(FOOTER).map(([col, links]) => (
              <div key={col}>
                <h5 className="text-sm font-semibold mb-4">{col}</h5>
                <ul className="space-y-3">
                  {links.map((l) => (
                    <li key={l}>
                      <a href="#top" className="text-sm text-secondary-auvra hover:text-white transition-colors">{l}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-8 border-t border-white/10">
          <p className="text-sm text-secondary-auvra">© 2025 AUVRA RWA. All rights reserved.</p>
          <div className="flex items-center gap-5">
            {[
              { Icon: Twitter, href: "https://x.com/AuvraRWA", label: "X" },
              { Icon: Send, href: "https://t.me/AuvraRWA", label: "Telegram" },
              { Icon: Instagram, href: "https://www.instagram.com/auvrarwa", label: "Instagram" },
            ].map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer"
                aria-label={s.label} data-testid={`social-${s.label.toLowerCase()}`}
                className="text-secondary-auvra hover:text-auvra-blue transition-colors">
                <s.Icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
